<template lang="">
    <div>
        <vs-button v-if="$store.getters.currentUser.channel_partner.demo_tenant_status === 'Build Complete'"
          @click.stop="onClickOpenDemoPortal" class="mr-16" icon-pack="feather" icon="icon-arrow-up-right">
          DEMO PORTAL</vs-button>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const TenantRepository = RepositoryFactory.get('tenant');
import { APP_LEVEL_2_URL, APP_DEMO_TENANT_AUTH_PAGE } from "@/constants/config";

import { APP_TENANT, APP_NAME, APP_PORTAL } from "@/constants/config";
import { pusher } from "@/constants/pusher";

export default {
    name: "DemoPortalButton",
    methods: {
        async onClickOpenDemoPortal() {
            const { data } = (await TenantRepository.getDemoPortalToken()).data
            const channel_partner = this.$store.getters.currentUser.channel_partner
            window.open(`https://${channel_partner.domain.split(".")[0]}.${APP_LEVEL_2_URL}${APP_DEMO_TENANT_AUTH_PAGE}${data.token}`)
        }
    },
    created() {
        const channel = pusher.subscribe(`notifications-${APP_NAME}-${APP_PORTAL}-${this.$store.getters.currentUser.channel_partner_id}`);
        const callback = (eventName, data) => {
            if (data.message) {
                this.$vs.dialog({
                    color: 'primary',
                    title: `Notifications`,
                    text: data.message,
                    acceptText: 'Close'
                })
            }
        };
        channel.bind_global(callback);
    },
}
</script>
<style lang="">

</style>